import(/* webpackChunkName: "serviceHub" */ '../../Styles/ServiceHub/serviceHub.scss');

await import(/* webpackChunkName: "sync" */ 'Feature/Common/code/Scripts/Common/sync');
await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');
await import(/* webpackChunkName: "requiredNumber" */ 'Foundation/Forms/code/Scripts/requiredNumber');
await import(/* webpackChunkName: "groupFormat" */ 'Common/Scripts/Common/groupFormat');
await import(/* webpackChunkName: "requiredAdvanced" */ 'Foundation/Forms/code/Scripts/requiredAdvanced');
await import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Scripts/forms');

const tileWrapperId = '.lottery-servicehub__tile__form-field';

window.am = window.am || {};

window.am.lotteryServiceHub = new function () {
    var that = this;

    that.validate = function (self) {
        var $self = $(self);
        var $form = $self.closest('form');
        var $input = $form.find('input');

        if ($input.length =! 0) {
            var result = $form.data('validator').element('#' + $input[0].id);
            if (result) {
                var url = $self.attr('href');
                if (url.indexOf('?') == -1) {
                    url += "?";
                } else {
                    url += "&";
                }
                $self.attr('href', url + "LotNumber=" + $input.val().replace(/\s/gm, ''));

                return true;
            }
        }

        return false;
    }

    that.init = function () {
        $(tileWrapperId).each(function (index) {
            var hyperLink = $(this).find('a');

            hyperLink.click(function () {
                return that.validate(this);
            });
        })

        const inputs = document.querySelectorAll('input[name="TicketNumber"], input[name="TicketNumberOrActivationCode"]');
        for (var i = 0; i < inputs.length; i++) {
            let input = inputs[i];
            input.addEventListener('focusout', function (inputValue) {
                if (inputValue.target.value == "") {
                    input.parentElement.classList.add('has-errors');
                    let inputErrorMessage = input.getAttribute('data-val-requiredadvanced');
                    let inputId = input.id + '-error';
                    let notificationContainer = input.parentElement.querySelector('.notification-container');
                    
                    if (notificationContainer) {
                        let notificationContainerSpan = notificationContainer.querySelector('span.field-validation-valid');
                        if (notificationContainerSpan) {
                            notificationContainerSpan.classList.remove('field-validation-valid');
                            notificationContainerSpan.classList.add('field-validation-error');
                            var tag = document.createElement("span");
                            tag.id = inputId;
                            var text = document.createTextNode(inputErrorMessage);
                            tag.appendChild(text);
                            notificationContainerSpan.appendChild(tag);
                        }                        
                    }
                }                
            })
        }
    }
}

window.am.lotteryServiceHub.init();